export default "__VITE_ASSET__CvX_dm1T__"